export const ADMIN_APP = 'admin';

export type ReleaseMap = Record<string, string>;

export interface WhatsNewSeenBody {
    version: string;
    app: typeof ADMIN_APP;
}

export function toReleaseMap(value: unknown): ReleaseMap {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    return Object.fromEntries(
        Object.entries(value).filter((entry): entry is [string, string] => {
            return typeof entry[1] === 'string';
        })
    );
}

export function shouldShowAdminRelease(releases: ReleaseMap, release: string): boolean {
    return releases[ADMIN_APP] !== release;
}

export function adminWhatsNewSeenBody(version: string): WhatsNewSeenBody {
    return { version, app: ADMIN_APP };
}

export function withAdminSeenRelease(
    releases: ReleaseMap,
    version: string,
    serverReleases?: ReleaseMap
): ReleaseMap {
    return serverReleases ?? { ...releases, [ADMIN_APP]: version };
}

export type MarkAdminSeen = (version: string) => Promise<ReleaseMap | undefined>;
export type ReleaseUpdate = (current: ReleaseMap) => ReleaseMap;

// Null when the server already holds this release, so a reopened modal never re-POSTs.
export async function recordAdminSeen(
    releases: ReleaseMap,
    version: string,
    markSeen: MarkAdminSeen
): Promise<ReleaseUpdate | null> {
    if (!shouldShowAdminRelease(releases, version)) return null;
    const serverReleases = await markSeen(version);
    return (current) => withAdminSeenRelease(current, version, serverReleases);
}
